export default __webpack_public_path__ + "static/media/purple-circle.ce84edb4.svg";